export const GET_POST_REQUEST = "get/post/request";
export const GET_POST_SUCCESS = "get/post/success";
export const GET_POST_FAILURE = "get/post/failure";

export const CREATE_POST_REQUEST = "create/post/request";
export const CREATE_POST_SUCCESS = "create/post/success";
export const CREATE_POST_FAILURE = "create/post/failure";

export const UPDATE_POST_REQUEST = "update/post/request";
export const UPDATE_POST_SUCCESS = "update/post/success";
export const UPDATE_POST_FAILURE = "update/post/failure";

export const DELETE_POST_REQUEST = "delete/post/request";
export const DELETE_POST_SUCCESS = "delete/post/success";
export const DELETE_POST_FAILURE = "delete/post/failure";
